/**
 * Ambil user login dari localStorage
 */
export const getAuthUser = () => {
  try {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  } catch (error) {
    console.error('Invalid user data in localStorage');
    return null;
  }
};

/**
 * Ambil role_id user
 */
export const getRoleId = () => {
  const user = getAuthUser();
  return user?.role_id || null;
};

/**
 * Cek apakah admin / supervisor
 */
export const isAdmin = () => {
  const roleId = getRoleId();
  return roleId === 1;
};

export const isKasie = () => {
  return getRoleId() === 2;
};

export const isUmum = () => {
  return getRoleId() === 7;
};

export const isAddMenu = () => {
  const roleId = getRoleId();
  return roleId === 1;
  // return roleId === 1 || roleId === 2;
};

/**
 * Ambil wilayah default user
 * - admin → all
 * - petugas → wilayah_id sendiri
 */
export const getDefaultWilayah = () => {
  const user = getAuthUser();

  if (!user) return null;

  if (user.role_id === 1 || user.role_id === 7) {
    return 'all';
  }

  return user.wilayah_id || null;
};
